import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import qs from 'qs';

import '../../index.css';
import Title from '../../components/Title';
import useYoutubeAccount from '../../hooks/useYoutubeAccount';
import cautionIcon from '../../icons/ic-caution.png';
import qMarkIcon from '../../icons/ic-qmark.png';
import qMarkOrangeIcon from '../../icons/ic-qmark-orange.png';
import GuideModal from '../../components/GuideModal';

function Account({ history }) {
  const [check, setCheck] = useState({
    accountCheck: false,
    apiCheck: false,
  });
  const [nextBtnDisabled, setNextBtnDisabled] = useState(false);
  const [data, setData] = useState(
    JSON.parse(window.sessionStorage.getItem('data'))
  );

  const curLocation = window.location.href.split('?')[0];
  const access_token = qs.parse(window.location.href.substr(0));
  const returnCode = access_token[curLocation + '?code'];

  const [isHovered, setIsHovered] = useState(false);
  const { getChannelId, googleLogin } = useYoutubeAccount();

  useEffect(() => {
    let v = check.accountCheck && check.apiCheck;
    setNextBtnDisabled(!v);
  }, [check]);

  const Push = () => {
    history.push({
      pathname: '/signup/select-shop',
      state: data,
    });
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (data.youtubeAPIKey != '' && check.apiCheck == false) {
      setCheck({ ...check, apiCheck: true });
    }
    if (data.youtubeAPIKey == '' && check.apiCheck == true) {
      setCheck({ ...check, apiCheck: false });
    }
  }, [data]);

  const Fetch = () => {
    if (!returnCode) {
      googleLogin();
    }
  };

  useEffect(() => {
    if (returnCode) {
      getChannelId(returnCode, (id) => {
        setData((prev) => ({ ...prev, youtubeAccount: id }));
        setCheck((prev) => ({ ...prev, accountCheck: true }));
      });
    }
  }, [returnCode, getChannelId]);

  return (
    <div>
      <Title title="계정 연동" />
      <div style={{ marginBottom: 200 }}>
        <Container>
          <SubTitleContainer>
            <SubTitle>계정 연동하기</SubTitle>
            <TooltipContainer>
              <GuideTextContainer>
                <img
                  src={cautionIcon}
                  style={{
                    display: 'inline-block',
                    width: '24px',
                    height: '24px',
                  }}
                  alt="주의 아이콘"
                />
                <span
                  style={{
                    fontSize: 16,
                    paddingBottom: 3,
                    color: '#FF7A00',
                  }}
                >
                  놀라지 마세요!
                </span>
              </GuideTextContainer>

              <Tooltip>
                <TooltipMessage>
                  연동하기 버튼 클릭 시 ‘확인되지 않은 앱’ 오류 화면이
                  출력되시나요?
                  <br />
                  Google 측에서 심사가 진행중인 상황이며 버그가 아닙니다.
                  <br />
                  <span
                    style={{
                      color: '#FF7A00',
                      fontSize: 14,
                      textDecorationLine: 'underline',
                    }}
                  >
                    고급 설정 - wizmon.co.kr
                  </span>
                  로 이동(안전하지 않음)을 차례로 클릭하시면 정상적으로 연동
                  진행 가능합니다.
                </TooltipMessage>
              </Tooltip>
            </TooltipContainer>
          </SubTitleContainer>
          <div>
            <button
              className={
                check.accountCheck ? 'normal-button-g' : 'normal-button-y'
              }
              disabled={check.accountCheck}
              style={{
                width: 383,
                height: 38,
                fontWeight: 600,
                paddingBottom: 1,
              }}
              onClick={() => Fetch()}
            >
              {check.accountCheck
                ? '유튜브 계정 연동됨'
                : '유튜브 계정 연동하기'}
            </button>
          </div>
          <InfoText>
            유튜브의 업로드 된 영상을 연동하여 사용할 수 있습니다.
          </InfoText>
        </Container>

        <Container>
          <SubTitleContainer>
            <SubTitle>유튜브 API Key</SubTitle>
            <GuideTextContainer
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <img
                src={qMarkOrangeIcon}
                style={{ width: 19.91, height: 19.91 }}
                alt="물음표 아이콘"
              />
              <span
                style={{
                  color: '#FF7A00',
                  fontSize: 14,
                  fontWeight: isHovered ? 600 : 400,
                  textDecoration: isHovered ? 'underline' : 'none',
                  textUnderlinePosition: 'under',
                }}
              >
                가이드
              </span>
              {isHovered && (
                <GuideModal
                  videoLink="https://youtu.be/SgAQ5j1rSa8?si=qk1Ne3GtcZ0vRyRQ"
                  pdfLink="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/guides/wizmon_youtubeAPI_guide_220729.pdf"
                />
              )}
            </GuideTextContainer>
          </SubTitleContainer>

          <div>
            <Input
              type="text"
              name="youtubeAPIKey"
              value={data.youtubeAPIKey}
              onChange={handleChange}
              placeholder={'유튜브 API Key를 입력해주세요.'}
            />
            <a
              href="https://developers.google.com/youtube/v3/getting-started"
              target="_blank"
              rel="noreferrer"
              style={{
                color: '#FF7A00',
                textDecoration: 'underline',
                textUnderlinePosition: 'under',
                cursor: 'pointer',
                fontSize: 14,
              }}
            >
              유튜브 API Key 생성하러 가기
            </a>
            <InfoText>
              유튜브 API Key와 도메인을 등록하여 쇼핑몰과 연동하세요.
            </InfoText>
          </div>
        </Container>
      </div>
      <div className="footer-div">
        <button
          className={nextBtnDisabled ? 'rounded-button-g' : 'rounded-button-y'}
          disabled={nextBtnDisabled}
          onClick={() => {
            setData({ ...data, pwConfirm: null, planNo: 1 });
            delete data.pwConfirm;
            window.sessionStorage.setItem('data', JSON.stringify(data));
            Push();
          }}
        >
          다음
        </button>
      </div>
    </div>
  );
}

export default withRouter(Account);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 42px;
`;

const SubTitle = styled.p`
  font-size: 18px;
`;

const SubTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 383px;
  margin-bottom: 16px;
`;

const InfoText = styled.p`
  color: #848484;
  font-size: 14px;
  margin-top: 6px;
`;

const Input = styled.input`
  width: 383px;
  height: 38px;
  margin-right: 10px;
  ::placeholder {
    color: #b5b5b5;
    font-size: 16px;
  }
`;
const Tooltip = styled.div`
  border: 1px solid #c4c4c4;
  background-color: #f8f8f8;
  border-radius: 5px;
  padding: 10px 14px;
  display: none;
  width: 700px;
`;

const TooltipMessage = styled.p`
  color: #848484;
  font-size: 14px;
`;

const GuideTextContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  gap: 6px;
`;

const TooltipContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  &:hover ${Tooltip} {
    display: block;
    position: absolute;
    top: 30px;
    z-index: 100;
  }
`;
